module.exports = __webpack_public_path__ + "static/media/edc.809e4fd7.svg";